import { render, staticRenderFns } from "./customerApplicationDialog.vue?vue&type=template&id=34a64e4a&scoped=true&"
import script from "./customerApplicationDialog.vue?vue&type=script&lang=js&"
export * from "./customerApplicationDialog.vue?vue&type=script&lang=js&"
import style0 from "./customerApplicationDialog.vue?vue&type=style&index=0&id=34a64e4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a64e4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34a64e4a')) {
      api.createRecord('34a64e4a', component.options)
    } else {
      api.reload('34a64e4a', component.options)
    }
    module.hot.accept("./customerApplicationDialog.vue?vue&type=template&id=34a64e4a&scoped=true&", function () {
      api.rerender('34a64e4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/customerApplicationDialog.vue"
export default component.exports